(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-zb-story-tabs]';
  const TAB_SELECTOR = '[role="tab"]';
  const PANEL_SELECTOR = '[role="tabpanel"]';

  function activateTab(root, selectedTab, moveFocus = false) {
    if (!root || !selectedTab) return;

    const tabs = Array.from(root.querySelectorAll(TAB_SELECTOR));
    const panels = Array.from(root.querySelectorAll(PANEL_SELECTOR));
    const controlledPanelId = selectedTab.getAttribute('aria-controls');

    tabs.forEach((tab) => {
      const isActive = tab === selectedTab;

      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const isActive = panel.id === controlledPanelId;

      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    if (moveFocus) {
      selectedTab.focus();
    }
  }

  document.addEventListener('click', (event) => {
    const selectedTab = event.target.closest(
      `${ROOT_SELECTOR} ${TAB_SELECTOR}`
    );

    if (!selectedTab) return;

    const root = selectedTab.closest(ROOT_SELECTOR);

    activateTab(root, selectedTab);
  });

  document.addEventListener('keydown', (event) => {
    const currentTab = event.target.closest(
      `${ROOT_SELECTOR} ${TAB_SELECTOR}`
    );

    if (!currentTab) return;

    const allowedKeys = [
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End'
    ];

    if (!allowedKeys.includes(event.key)) return;

    event.preventDefault();

    const root = currentTab.closest(ROOT_SELECTOR);
    const tabs = Array.from(root.querySelectorAll(TAB_SELECTOR));
    const currentIndex = tabs.indexOf(currentTab);

    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') {
      nextIndex = (currentIndex + 1) % tabs.length;
    }

    if (event.key === 'ArrowLeft') {
      nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    }

    if (event.key === 'Home') {
      nextIndex = 0;
    }

    if (event.key === 'End') {
      nextIndex = tabs.length - 1;
    }

    activateTab(root, tabs[nextIndex], true);
  });
})();